import Header from "./components/Header";
import Hero from "./components/Hero";
import FeatureModule from "./components/FeatureModule";
import LeidianModule from "./components/LeidianModule";
import QingdanModule from "./components/QingdanModule";
import MailuoModule from "./components/MailuoModule";
import ChangchangModule from "./components/ChangchangModule";
import BaoliaoModule from "./components/BaoliaoModule";
import SubscribeFooter from "./components/SubscribeFooter";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 font-body text-foreground-900">
      <Header />
      <main>
        <Hero />
        <FeatureModule />
        <LeidianModule />
        <QingdanModule />
        <MailuoModule />
        <ChangchangModule />
        <BaoliaoModule />
      </main>
      <SubscribeFooter />
    </div>
  );
}